function MissionAndVission(){
    return(
        <section className="mission-vission">
            <div className="container">
                <div className="row">
                    <div className="col-6">
                        <div className="mav-div">
                            <img className="img-fluid mb20" src="./images/mission.jpg" alt="" height={382} width={555}/>
                            <h3>Our Mission</h3>
                            <p>To empower businesses to expand and succeed in the global marketplace by delivering innovative, tailored logistics solutions that bring efficiency, reliability, and growth.</p>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="mav-div">
                            <img className="img-fluid mb20" src="./images/vision.jpg" alt="" height={382} width={555}/>
                            <h3>Our Vision</h3>
                            <p>To be a global leader in export-import logistics and supply chain management, offering services that redefine efficiency and enable seamless trade across borders.</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default MissionAndVission;